export type SearchParamOption = {
  label: string;
  value: string;
};

export const parseDateFromSearchParam = (
  dateValue: string | null,
): Date | undefined => {
  if (!dateValue) return undefined;

  const parsedDate = new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) return undefined;

  return parsedDate;
};

export const buildSearchOption = (
  value: string | null,
  label?: string | null,
): SearchParamOption | null => {
  if (!value) return null;

  return {
    value,
    label: label ?? value,
  };
};

export const buildSearchOptionFromSearchParams = (
  searchParams: URLSearchParams,
  valueKey: string,
  labelKey: string,
): SearchParamOption | null => {
  return buildSearchOption(
    searchParams.get(valueKey),
    searchParams.get(labelKey),
  );
};